import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color.ts';
import Icon from '@mlb/react-patterns/components/Icon/icon.tsx';

import { DateUtils } from 'bdvp-common/src/utils';

const Duration = styled.span`
    margin-left: 4px;
    color: ${ ({ color }) => color };
`;

const ReelDuration = (props) => {

    const {
        mediaId,
        reel,
    } = props;

    const { trimmedDuration, originalDuration } = reel.reelClips?.find((item) => item.mediaId === mediaId);

    const totalDuration = DateUtils.formatSecondsToTime(originalDuration);

    if (!trimmedDuration || trimmedDuration === originalDuration) {

        return totalDuration;

    }

    return (
        <>
            <Icon
                name={'scissors'}
                fill={COLORS.mlbWhite}
                width={11}
            />
            <Duration color={COLORS.mlbWhite}>
                {DateUtils.formatSecondsToTime(trimmedDuration)}
            </Duration>
            <Duration color={COLORS.mlbGrey3}>
                ({totalDuration})
            </Duration>
        </>
    );

};

ReelDuration.propTypes = {
    mediaId: PropTypes.string.isRequired,
    reel: PropTypes.shape({
        reelClips: PropTypes.array,
    }).isRequired,
};

export default ReelDuration;
